// src/utils/logoService.js

const KNOWN_SERVICES = {
    'netflix': 'bg-red-500',
    'spotify': 'bg-green-500',
    'adobe': 'bg-blue-600',
    'amazon': 'bg-amber-500',
    'apple': 'bg-gray-800',
    'google': 'bg-blue-500',
    'chatgpt': 'bg-teal-600',
    'openai': 'bg-teal-600',
    'github': 'bg-gray-900',
    'hulu': 'bg-green-400',
    'disney': 'bg-blue-900',
    'hbo': 'bg-purple-700',
    'youtube': 'bg-red-600',
    'figma': 'bg-pink-500',
    'notion': 'bg-gray-800',
    'slack': 'bg-purple-600',
    'zoom': 'bg-blue-500',
    'dropbox': 'bg-blue-600',
    'canva': 'bg-cyan-500',
    'mailchimp': 'bg-yellow-400',
    'stripe': 'bg-indigo-600',
    'aws': 'bg-orange-500',
    'vercel': 'bg-black',
    'x': 'bg-black',
    'twitter': 'bg-blue-400',
    'linkedin': 'bg-blue-700',
    'microsoft': 'bg-blue-600',
    'xbox': 'bg-green-600',
    'playstation': 'bg-blue-700',
    'nintendo': 'bg-red-600',
    'patreon': 'bg-orange-600',
    'salesforce': 'bg-blue-500',
    'creative cloud': 'bg-red-500',
};

const FallbackColors = [
    'bg-blue-500', 'bg-green-500', 'bg-purple-500', 'bg-pink-500',
    'bg-indigo-500', 'bg-rose-500', 'bg-teal-500', 'bg-cyan-500',
    'bg-orange-500', 'bg-violet-500', 'bg-fuchsia-500', 'bg-sky-500'
];

export const getSubscriptionLogoInfo = (name) => {
    if (!name || typeof name !== 'string') {
        return {
            initial: '?',
            colorClass: 'bg-gray-400'
        };
    }

    const cleanName = name.trim();
    const lowerName = cleanName.toLowerCase();

    // Find exact or partial match for known services
    let colorClass = null;
    for (const [key, value] of Object.entries(KNOWN_SERVICES)) {
        if (lowerName.includes(key)) {
            colorClass = value;
            break;
        }
    }

    // If not found in known services, deterministically pick a color from FallbackColors based on the name's characters
    if (!colorClass) {
        let hash = 0;
        for (let i = 0; i < lowerName.length; i++) {
            hash = lowerName.charCodeAt(i) + ((hash << 5) - hash);
        }
        const index = Math.abs(hash) % FallbackColors.length;
        colorClass = FallbackColors[index];
    }

    // First letter for initial
    const initial = cleanName.charAt(0).toUpperCase();

    return {
        initial,
        colorClass
    };
};
